const STAGES = {
  fresh: {
    label: 'Fresh',
    color: '#475569',
    bg: '#f1f5f9',
    border: '#cbd5e1',
    tooltip: 'No qualifying compliance history in the lookback windows.',
  },
  investigated: {
    label: 'Investigated',
    color: '#6d28d9',
    bg: '#ede9fe',
    border: '#c4b5fd',
    tooltip: 'ECDD or material investigation activity within the last 12 months.',
  },
  reported: {
    label: 'Reported',
    color: '#1e40af',
    bg: '#dbeafe',
    border: '#93c5fd',
    tooltip: 'At least one Suspicious Matter Report filed to AUSTRAC.',
  },
  prohibited: {
    label: 'Prohibited',
    color: '#991b1b',
    bg: '#fee2e2',
    border: '#fecaca',
    tooltip: 'Patron must not be served — sanctions match or internal prohibition.',
  },
}

function stageMeta(stage) {
  const key = String(stage || 'fresh').toLowerCase()
  return STAGES[key] || STAGES.fresh
}

export default function ComplianceStageBadge({ stage, size = 'default', className = '' }) {
  const meta = stageMeta(stage)
  const compact = size === 'compact'
  const padding = compact ? 'px-2 py-0.5 text-[11px]' : 'px-2.5 py-0.5 text-xs'

  return (
    <span
      className={`inline-flex items-center font-semibold rounded-full border ${padding} ${className}`}
      style={{ backgroundColor: meta.bg, color: meta.color, borderColor: meta.border }}
      title={meta.tooltip}
    >
      {meta.label}
    </span>
  )
}
